/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconRobot1 = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M.75 16.5a1.5 1.5 0 0 1 3 0M2.25 15V9.75a3 3 0 0 1 3-3h1.5M23.25 16.5a1.5 1.5 0 0 0-3 0" />
        <path d="M21.75 15V9.75a3 3 0 0 0-3-3h-1.5M17.25 6.75a10.88 10.88 0 0 1 .75 4.5 14.047 14.047 0 0 1-.372 3.363 1.5 1.5 0 0 1-1.456 1.137H7.828a1.5 1.5 0 0 1-1.456-1.137A14.047 14.047 0 0 1 6 11.25a10.88 10.88 0 0 1 .75-4.5h10.5z" />
        <path d="M10.5 15.75v6.75a.75.75 0 0 1-.75.75H7.5v-7.536M5.25 23.25H7.5M13.5 15.75v6.75c0 .414.336.75.75.75h2.25v-7.536M18.75 23.25H16.5M12 .75a3 3 0 0 0-3 3v3h6v-3a3 3 0 0 0-3-3zM14.625 9.75c.207 0 .375.168.375.375M14.25 10.125c0-.207.168-.375.375-.375M14.625 10.5a.375.375 0 0 1-.375-.375M15 10.125a.375.375 0 0 1-.375.375M9 10.5h2.25" />
      </g>
    </svg>
  ),
);
